/** Import ReactJS */
import React, { useEffect, useState } from 'react'

import { withRouter } from 'react-router-dom'
/** Material UI import section */
import { withStyles } from '@material-ui/core/styles'
/**Import section components */

import { Divider, List, ListItem, ListItemText, TextField, Typography } from '@material-ui/core'
import { Translate } from 'react-localize-redux'
import ReactSelect from 'react-select'
import { incotermOptions } from '../../../../store/helpers/SelectOptions'
import ListDocumentsComponent from './ListDocumentsComponent'
import SelectSupplierComponent from './SelectSupplierComponent'

/** Resources import section */
const useStyle = (theme) => ({})

const InternationalComponent = (props) => {
	//function props section
	const { updateLoadAlertItemProperty, onLateralPanelConfig, onSendNotificationToSupplier, deleteAnnexesFiles } = props
	//object props section
	const { internacionalData } = props
	//tab props section
	const { tabSelected } = props
	//Array props section
	// const { userRolesByCompany } = props
	//bool props section
	const { canBeEditData, canBeEditInternalUserData } = props
	if (!internacionalData) return null
	const [operationType, setOperationType] = useState('')

	useEffect(() => {
		if (internacionalData && internacionalData.incoterm) {
			setOperationType(internacionalData.incoterm)
		}
	}, [internacionalData])

	const onUpdatePropertyCommon = (property, value) => {
		let objectProperties = {
			token: internacionalData.token,
		}
		objectProperties[property] = value
		updateLoadAlertItemProperty(objectProperties)
	}
	const selectedOption = incotermOptions.find((option) => option.value === operationType)

	const customStyles = {
		control: (provided) => ({
			...provided,
			height: '32px',
			width: '500px',
		}),
		menu: (provided) => ({
			...provided,
			width: '250px',
			minWidth: '100%',
		}),
		menuList: (provided) => ({
			...provided,
			display: 'flex',
			flexDirection: 'column',
		}),
		singleValue: (provided) => ({
			...provided,
			width: '250px',
		}),
	}

	return (
		<>
			{tabSelected === '1' && (
				<List style={{ backgroundColor: "rgb(250, 250, 250)" }}>
					<SelectSupplierComponent
						title={<Translate id='loadAlerts.transportLine' />}
						updateLoadAlertItemProperty={updateLoadAlertItemProperty}
						item={internacionalData}
						onSendNotificationToSupplier={onSendNotificationToSupplier}
						canBeEditInternalUserData={canBeEditInternalUserData}
					/>
					<ListItem>
						<ListItemText
							secondary={
								<React.Fragment>
									<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
										<Typography
											component='span'
											variant='body2'
											color='textPrimary'
											style={{ whiteSpace: 'nowrap' }}
										>
											<strong>
												{' '}
												<Translate id='loadAlerts.referenceNumber' />:
											</strong>
										</Typography>
										{internacionalData && (
											// IsSelectorNullOrEmpty(internacionalData.referenceNumber) && (
											<TextField
												fullWidth
												id='outlined-size-small'
												label={''}
												onBlur={(event) => {
													onUpdatePropertyCommon('ReferenceNumber', event.target.value)
												}}
												variant='outlined'
												InputProps={{
													style: {
														padding: '5px',
														height: '32px',
													},
												}}
												disabled={!canBeEditData}
												defaultValue={internacionalData.referenceNumber}
											/>
										)}
									</div>
								</React.Fragment>
							}
						/>
						<ListItemText
							secondary={
								<React.Fragment>
									<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
										<Typography
											component='span'
											variant='body2'
											color='textPrimary'
											style={{ whiteSpace: 'nowrap' }}
										>
											<strong>
												{' '}
												<Translate id='loadAlerts.collectionDate' />:
											</strong>
										</Typography>
										{/* {internacionalData && internacionalData.collectionDate}
										{internacionalData && IsNullOrEmpty(internacionalData.collectionDate) && ( */}
										{internacionalData && (
											<TextField
												fullWidth
												id='outlined-size-small'
												label={''}
												type='date'
												onBlur={(event) => {
													onUpdatePropertyCommon('CollectionDate', event.target.value)
												}}
												variant='outlined'
												InputProps={{
													style: {
														padding: '5px',
														height: '32px',
													},
												}}
												disabled={!canBeEditData}
												defaultValue={internacionalData.collectionDate}
											/>
										)}
									</div>
								</React.Fragment>
							}
						/>
					</ListItem>
					<Divider />
					<ListItem>
						{/* <ListItemText
							secondary={
								<React.Fragment>
									<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
										<Typography
											component='span'
											variant='body2'
											color='textPrimary'
											style={{ whiteSpace: 'nowrap' }}
										>
											<strong>
												<Translate id='loadAlerts.transportLine' />:
											</strong>
										</Typography>
										
										{internacionalData && (
											<TextField
												fullWidth
												id='outlined-size-small'
												label={''}
												onBlur={(event) => {
													onUpdatePropertyCommon('TransportLine', event.target.value)
												}}
												variant='outlined'
												InputProps={{
													style: {
														padding: '5px',
														height: '32px',
													},
												}}
												disabled={!canBeEditData}
												defaultValue={internacionalData.transportLine}
											/>
										)}
									</div>
								</React.Fragment>
							}
						/> */}
						<ListItemText
							secondary={
								<React.Fragment>
									<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
										<Typography
											component='span'
											variant='body2'
											color='textPrimary'
											style={{ whiteSpace: 'nowrap' }}
										>
											<strong>
												<Translate id='loadAlerts.countryOrigin' />:
											</strong>
										</Typography>
										{/* {internacionalData && internacionalData.countryOrigin}
										{internacionalData && IsNullOrEmpty(internacionalData.countryOrigin) && ( */}
										{internacionalData && (
											<TextField
												fullWidth
												id='outlined-size-small'
												label={''}
												onBlur={(event) => {
													onUpdatePropertyCommon('CountryOrigin', event.target.value)
												}}
												variant='outlined'
												InputProps={{
													style: {
														padding: '5px',
														height: '32px',
													},
												}}
												disabled={!canBeEditData}
												defaultValue={internacionalData.countryOrigin}
											/>
										)}
									</div>
								</React.Fragment>
							}
						/>
					</ListItem>
					<Divider />
					<ListItem>
						<ListItemText
							secondary={
								<React.Fragment>
									<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
										<Typography
											component='span'
											variant='body2'
											color='textPrimary'
											style={{ whiteSpace: 'nowrap' }}
										>
											<strong>
												{' '}
												<Translate id='loadAlerts.departureAirport' />:
											</strong>
										</Typography>
										{/* {internacionalData && internacionalData.departureAirport}
										{internacionalData && IsNullOrEmpty(internacionalData.departureAirport) && ( */}
										{internacionalData && (
											<TextField
												fullWidth
												id='outlined-size-small'
												label={''}
												onBlur={(event) => {
													onUpdatePropertyCommon('DepartureAirport', event.target.value)
												}}
												variant='outlined'
												InputProps={{
													style: {
														padding: '5px',
														height: '32px',
													},
												}}
												disabled={!canBeEditData}
												defaultValue={internacionalData.departureAirport}
											/>
										)}
									</div>
								</React.Fragment>
							}
						/>
						<ListItemText
							secondary={
								<React.Fragment>
									<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
										<Typography
											component='span'
											variant='body2'
											color='textPrimary'
											style={{ whiteSpace: 'nowrap' }}
										>
											<strong>
												{' '}
												<Translate id='loadAlerts.departureCity' />:
											</strong>
										</Typography>
										{/* {internacionalData && internacionalData.departureCity}
										{internacionalData && IsNullOrEmpty(internacionalData.departureCity) && ( */}
										{internacionalData && (
											<TextField
												fullWidth
												id='outlined-size-small'
												label={''}
												onBlur={(event) => {
													onUpdatePropertyCommon('DepartureCity', event.target.value)
												}}
												variant='outlined'
												InputProps={{
													style: {
														padding: '5px',
														height: '32px',
													},
												}}
												disabled={!canBeEditData}
												defaultValue={internacionalData.departureCity}
											/>
										)}
									</div>
								</React.Fragment>
							}
						/>
					</ListItem>
					<Divider />
					<ListItem>
						<ListItemText
							secondary={
								<React.Fragment>
									<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
										<Typography
											component='span'
											variant='body2'
											color='textPrimary'
											style={{ whiteSpace: 'nowrap' }}
										>
											<strong>
												{' '}
												<Translate id='loadAlerts.arrivalAirport' />:
											</strong>
										</Typography>
										{/* {internacionalData && internacionalData.arrivalAirport}
										{internacionalData && IsNullOrEmpty(internacionalData.arrivalAirport) && ( */}
										{internacionalData && (
											<TextField
												fullWidth
												id='outlined-size-small'
												label={''}
												onBlur={(event) => {
													onUpdatePropertyCommon('ArrivalAirport', event.target.value)
												}}
												variant='outlined'
												InputProps={{
													style: {
														padding: '5px',
														height: '32px',
													},
												}}
												disabled={!canBeEditData}
												defaultValue={internacionalData.arrivalAirport}
											/>
										)}
									</div>
								</React.Fragment>
							}
						/>
						<ListItemText
							secondary={
								<React.Fragment>
									<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
										<Typography
											component='span'
											variant='body2'
											color='textPrimary'
											style={{ whiteSpace: 'nowrap' }}
										>
											<strong>
												{' '}
												<Translate id='loadAlerts.arrivalCity' />:
											</strong>
										</Typography>
										{/* {internacionalData && internacionalData.arrivalCity}
										{internacionalData && IsNullOrEmpty(internacionalData.arrivalCity) && ( */}
										{internacionalData && (
											<TextField
												fullWidth
												id='outlined-size-small'
												label={''}
												onBlur={(event) => {
													onUpdatePropertyCommon('ArrivalCity', event.target.value)
												}}
												variant='outlined'
												InputProps={{
													style: {
														padding: '5px',
														height: '32px',
													},
												}}
												disabled={!canBeEditData}
												defaultValue={internacionalData.arrivalCity}
											/>
										)}
									</div>
								</React.Fragment>
							}
						/>
					</ListItem>
					<Divider />
					<ListItem>
						<ListItemText
							secondary={
								<React.Fragment>
									<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
										<Typography
											component='span'
											variant='body2'
											color='textPrimary'
											style={{ whiteSpace: 'nowrap' }}
										>
											<strong>
												{' '}
												<Translate id='loadAlerts.trackingGuide' />:
											</strong>
										</Typography>
										{/* {internacionalData && internacionalData.trackingGuide}
										{internacionalData && IsNullOrEmpty(internacionalData.trackingGuide) && ( */}
										{internacionalData && (
											<TextField
												fullWidth
												id='outlined-size-small'
												label={''}
												onBlur={(event) => {
													onUpdatePropertyCommon('TrackingGuide', event.target.value)
												}}
												variant='outlined'
												InputProps={{
													style: {
														padding: '5px',
														height: '32px',
													},
												}}
												disabled={!canBeEditData}
												defaultValue={internacionalData.trackingGuide}
											/>
										)}
									</div>
								</React.Fragment>
							}
						/>
						<ListItemText
							secondary={
								<React.Fragment>
									<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
										<Typography
											component='span'
											variant='body2'
											color='textPrimary'
											style={{ whiteSpace: 'nowrap' }}
										>
											<strong>
												{' '}
												<Translate id='loadAlerts.downloadTerminal' />:
											</strong>
										</Typography>
										{/* {internacionalData && internacionalData.downloadTerminal}
										{internacionalData && IsNullOrEmpty(internacionalData.downloadTerminal) && ( */}
										{internacionalData && (
											<TextField
												fullWidth
												id='outlined-size-small'
												label={''}
												onBlur={(event) => {
													onUpdatePropertyCommon('DownloadTerminal', event.target.value)
												}}
												variant='outlined'
												InputProps={{
													style: {
														padding: '5px',
														height: '32px',
													},
												}}
												disabled={!canBeEditData}
												defaultValue={internacionalData.downloadTerminal}
											/>
										)}
									</div>
								</React.Fragment>
							}
						/>
					</ListItem>
					<Divider />
					<ListItem>
						<ListItemText
							secondary={
								<React.Fragment>
									<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
										<Typography
											component='span'
											variant='body2'
											color='textPrimary'
											style={{ whiteSpace: 'nowrap' }}
										>
											<strong>
												{' '}
												<Translate id='loadAlerts.etd' />:
											</strong>
										</Typography>
										{/* {internacionalData && internacionalData.etd} */}
										{/* {internacionalData && IsNullOrEmpty(internacionalData.etd) && ( */}
										{internacionalData && (
											<TextField
												fullWidth
												id='outlined-size-small'
												label={''}
												type='date'
												onBlur={(event) => {
													onUpdatePropertyCommon('Etd', event.target.value)
												}}
												variant='outlined'
												InputProps={{
													style: {
														padding: '5px',
														height: '32px',
													},
												}}
												disabled={!canBeEditData}
												defaultValue={internacionalData.etd}
											/>
										)}
									</div>
								</React.Fragment>
							}
						/>
						<ListItemText
							secondary={
								<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
									<Typography
										component='span'
										variant='body2'
										color='textPrimary'
										style={{ whiteSpace: 'nowrap' }}
									>
										<strong>
											{' '}
											<Translate id='loadAlerts.eta' />:
										</strong>
									</Typography>
									{/* {internacionalData && internacionalData.eta} */}
									{/* {internacionalData && IsNullOrEmpty(internacionalData.eta) && ( */}
									{internacionalData && (
										<TextField
											fullWidth
											id='outlined-size-small'
											label={''}
											type='date'
											onBlur={(event) => {
												onUpdatePropertyCommon('Eta', event.target.value)
											}}
											variant='outlined'
											InputProps={{
												style: {
													padding: '5px',
													height: '32px',
												},
											}}
											disabled={!canBeEditData}
											defaultValue={internacionalData.eta}
										/>
									)}
								</div>
							}
						/>
					</ListItem>
					<Divider />
					<ListItem>
						<ListItemText
							secondary={
								<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
									<Typography
										component='span'
										variant='body2'
										color='textPrimary'
										style={{ whiteSpace: 'nowrap' }}
									>
										<strong>
											{' '}
											<Translate id='loadAlerts.incoterm' />:
										</strong>
									</Typography>
									{/* {internacionalData && internacionalData.incoterm} */}
									{/* {internacionalData && IsNullOrEmpty(internacionalData.incoterm) && ( */}
									{internacionalData && (
										<ReactSelect
											placeholder={<Translate id='loadAlerts.incoterm' />}
											options={incotermOptions}
											value={selectedOption}
											onChange={(selectedOption) => {
												setOperationType(selectedOption.value)
												onUpdatePropertyCommon('Incoterm', selectedOption.value)
											}}
											isDisabled={!canBeEditData}
											styles={customStyles}
										/>
									)}
								</div>
							}
						/>
						<ListItemText
							secondary={
								<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
									<Typography
										component='span'
										variant='body2'
										color='textPrimary'
										style={{ whiteSpace: 'nowrap' }}
									>
										<strong>
											{' '}
											<Translate id='loadAlerts.incotermPlace' />:
										</strong>
									</Typography>
									{/* {internacionalData && internacionalData.incotermPlace} */}
									{/* {internacionalData && IsNullOrEmpty(internacionalData.incotermPlace) && ( */}
									{internacionalData && (
										<TextField
											fullWidth
											id='outlined-size-small'
											label={''}
											onBlur={(event) => {
												onUpdatePropertyCommon('IncotermPlace', event.target.value)
											}}
											variant='outlined'
											InputProps={{
												style: {
													padding: '5px',
													height: '32px',
												},
											}}
											disabled={!canBeEditData}
											defaultValue={internacionalData.incotermPlace}
										/>
									)}
								</div>
							}
						/>
					</ListItem>
					<Divider />
					<ListDocumentsComponent
						panel='AddInvoiceDocuments'
						title='loadAlerts.invoice'
						documents={internacionalData.invoiceDocument}
						onLateralPanelConfig={onLateralPanelConfig}
					/>
					<ListDocumentsComponent
						panel='AddAnnexesDocumentes'
						title='loadAlerts.annexes'
						documents={internacionalData.annexesDocument}
						onLateralPanelConfig={onLateralPanelConfig}
						deleteFiles={deleteAnnexesFiles}
					/>
					
				</List>
			)}
		</>
	)
}

InternationalComponent.propTypes = {}

InternationalComponent.defaultProps = {}
export default withRouter(withStyles(useStyle, { withTheme: true })(InternationalComponent))
